import React, { useState, useEffect, Suspense } from 'react';
import './Oferta.css';
import PageFooter from '../components/PageFooter';

// Lazy load components
const LazyPageBanner = React.lazy(() => import('../components/PageBanner'));
const LazyOfertaForm = React.lazy(() => import('../components/Oferta/OfertaForm'));
const LazyOfertaCard = React.lazy(() => import('../components/Oferta/OfertaCard'));

const Oferta = () => {
  const [selectedConvocatoriaCodigo, setSelectedConvocatoriaCodigo] = useState(null);

  // Scroll to the top when the component is mounted
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Function to update the selected convocatoria
  const handleConvocatoriaChange = (codigo) => {
    setSelectedConvocatoriaCodigo(codigo);
  };

  return (
    <div className="oferta-page">
      <div className="oferta-page-banner">
        {/* Lazy load the PageBanner */}
        <Suspense fallback={<div>Loading Banner...</div>}>
          <LazyPageBanner />
        </Suspense>
      </div>
      <div className="oferta-page-content">
        <div className="oferta-page-information">
          <div className="oferta-page-card">
            {/* Lazy load the OfertaCard */}
            <Suspense fallback={<div>Loading Oferta Card...</div>}>
              <LazyOfertaCard onConvocatoriaSelect={handleConvocatoriaChange} />
            </Suspense>
          </div>
          <div className="oferta-page-form">
            {/* Lazy load the OfertaForm */}
            <Suspense fallback={<div>Loading Oferta Form...</div>}>
              <LazyOfertaForm selectedConvocatoriaCodigo={selectedConvocatoriaCodigo} />
            </Suspense>
          </div>
        </div>
      </div>
      <div className="oferta-page-footer">
      <PageFooter />
      </div>
    </div>
  );
};

export default Oferta;
